import type Projection from 'modules/reports/store/models/Projection'
import { ProjectionParams } from 'modules/reports/store/models/Projection'

export const hasDeprecatedPath = (projection: Projection): boolean => {
  return !!projection.attributes.has_deprecated_path
}

export const pathWithFunction = (projection: Projection | ProjectionParams): string => {
  return projection.function ? `${projection.function}.${projection.path}` : projection.path
}
